import React, { Component, Suspense } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import {
  DsCssBaseline,
  DsNotistackProvider,
  Experimental_CssVarsProvider as CssVarsProvider,
  getTheme,
  createTheme
} from '@am92/react-design-system'

import { TAppStore } from './Configurations/AppStore'
import AppInitializer from './AppInitializer'
import ThemeManager from './ThemeManager'
import GlobalErrorComponent from './GlobalErrorComponent'
import { getThemeReducer } from './Redux/Theme/Selectors'
import { THEME_MODE_STORAGE_KEY } from './Constants/THEME'
import NetworkStatusToast from './NetworkStatus'

interface IAppProps extends PropsFromRedux {
  persisted: boolean
}

const BREAKPOINT_VALUES_DEEPTRADE = {
  xs: 0,
  sm: 1024,
  md: 1200,
  lg: 1350,
  xl: 1500
}

export const overiddenTheme = createTheme({
  breakpoints: {
    values: { ...BREAKPOINT_VALUES_DEEPTRADE }
  }
})

class App extends Component<IAppProps> {
  render() {
    const { persisted, theme } = this.props
    const { fontFamily, palette, defaultMode } = theme

    const AppTheme = getTheme(palette, fontFamily)

    const ExtendedTheme = {
      ...AppTheme,
      breakpoints: overiddenTheme.breakpoints
    }

    return (
      <CssVarsProvider
        theme={ExtendedTheme}
        defaultMode={defaultMode}
        modeStorageKey={THEME_MODE_STORAGE_KEY}
      >
        <DsCssBaseline enableColorScheme>
          <NetworkStatusToast />
          <ThemeManager />
          {persisted && (
            <GlobalErrorComponent>
              <DsNotistackProvider>
                <AppInitializer />
              </DsNotistackProvider>
            </GlobalErrorComponent>
          )}
        </DsCssBaseline>
      </CssVarsProvider>
    )
  }
}

const mapStateToProps = (state: TAppStore) => {
  const theme = getThemeReducer(state)

  return {
    theme
  }
}

const connector = connect(mapStateToProps, null)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(App)
